var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(!_vm.finished)?_c('div',{staticClass:"loader"},[_c('div',{staticClass:"load-status-bar",style:({ width: _vm.progress })}),_c('div',{staticClass:"icon"}),_c('div',{staticClass:"overlay"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }